import { render, staticRenderFns } from "./ZelleTab.vue?vue&type=template&id=69af0160&scoped=true"
import script from "./ZelleTab.vue?vue&type=script&lang=js"
export * from "./ZelleTab.vue?vue&type=script&lang=js"
import style0 from "./ZelleTab.vue?vue&type=style&index=0&id=69af0160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69af0160",
  null
  
)

export default component.exports